// extracted by mini-css-extract-plugin
module.exports = {"Headline":"PlanSummary_Headline__Xgs8J"};